'use client';
import { useState } from 'react';

/**
 * Тип входных данных для хука `useUncontrolled`.
 *
 * @typedef {Object} UseUncontrolledInput
 * @property {T} [value] - Значение для управляемого состояния.
 * @property {T} [defaultValue] - Начальное значение для неуправляемого состояния.
 * @property {T} [finalValue] - Конечное значение для неуправляемого состояния, если не предоставлены `value` и `defaultValue`.
 * @property {(value: T) => void} [onChange] - Обработчик изменения значения для управляемого состояния.
 */ var useUncontrolled = function(param) {
    var value = param.value, defaultValue = param.defaultValue, finalValue = param.finalValue, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function() {
        return Function;
    } : _param_onChange;
    var _useState = useState(defaultValue !== undefined ? defaultValue : finalValue), uncontrolledValue = _useState[0], setUncontrolledValue = _useState[1];
    var handleUncontrolledChange = function(value) {
        setUncontrolledValue(value);
        onChange == null ? void 0 : onChange(value);
    };
    if (value !== undefined) {
        return [
            value,
            onChange,
            true
        ];
    }
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
};

export { useUncontrolled };
